import { KontentImage } from '@components/gassan-ui/Image/KontentImage'
import { Box, CleanButton } from '@gassan-ui'
import * as Elements from '@lib/kontent/models/Elements'
import { FC } from 'react'
import styled from 'styled-components'
import { OpacityProps, opacity } from 'styled-system'

const Button = styled(CleanButton)<OpacityProps>`
  display: flex;
  min-width: 15%;
  scroll-snap-align: start;
  width: 100%;
  transition: opacity 0.2s ease-in-out;
  ${opacity};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      opacity: 1;
    }
  }
`
type Props = {
  images: Elements.AssetsElement['value']
  onSelect: (number) => void
  index: number
}

const Thumbnails: FC<Props> = ({ images, onSelect, index }) => {
  return (
    <>
      {images.map((image, key) => (
        <Box display="contents" key={key}>
          <Button onClick={() => onSelect(key)} opacity={key === index ? 1 : 0.4}>
            <KontentImage className="aspect-[20/13]" alt={image.description} src={image.url} />
          </Button>
          {key !== images.length - 1 && <Box minWidth="0.5rem" height="100%" />}
        </Box>
      ))}
    </>
  )
}

export default Thumbnails
